export const bioText = {
	id: 'about',
	lightBg: true,
	lightText: false,
	lightTextDesc: false,
	topLine: 'about me',
	// headline: 'I love changes and stimulation',
	description1: `Rewind to 2020, amidst the chaotic pandemic, I made a pivotal decision to pursue a career in software engineering, and my life has never been the same.`,
	// description1:
	// 	'Coming from liberal art background, I am a multidisciplinary person at heart, and am passionate about learning new technologies.',
	description2:
		"On September 20th, 2021, I pushed my very first lines of code to production as a junior software engineer. It was the first time writing code not for make-believe users, but for real people with real-world needs. To know my work could make an impact feels incredible.",
	description3: "Fast-forward to today, I've been fortunate to contribute to many applications—from content management systems and landing pages to interfaces for kiosk machines. I like to think of myself as software—constantly iterating, evolving with each version. Every cycle of growth is both an endpoint and the start of something new.",
	description4: "When I'm not at the computer, my interest is climbing and hiking. Lately I've been wanting to try trail running as well.",
	imgStart: true,
	img: require('../../images/profile.jpg'),
	alt: ''
}

/**
 * in 2020 during the midst of the chaotic pandemic, i made a pivital decision to change my career to software engineer.
 * 
 * on 2021, september 20th, the very first time i pushed my code up to production during my first swe job, 
 *  it’s the first time I wrote something that’s not for make-believe users, but for real users with real world needs.
 *  the excitemtnt knowing that my code can make an impact to my users feel powerful.
 * 
 * i love solving problems and building something tabgible out of nothing. i love to execute ideas and turn them into applications.
 * work aside, i'm a climber and hiker. i enjoy climbing, bouldering and hiking. 
 */